import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import "../TopCakes/topCakes.css";
import { WEDDING_CAKES } from "./weddingCakeData";

const WeddingCakes = () => {
  const navigate = useNavigate();

  const onCardClick = (cakeId) => {
    navigate(`/cakes/${cakeId}`);
  };

  return (
    <div
      className="container-sm px-4 px-xs-5 px-sm-0 align-items-center justify-content-center home__topnft"
      id="wedding-cakes">
      <hr/>
      <h2 className="text-center">Wedding Cakes</h2>
      <p className="home__topnft_p mb-4">
        Custom tiered cakes, designed with you. Tell us your date and guest count and we will prepare a quote.
      </p>
      <div className="row">
        {WEDDING_CAKES.map((cake) => (
          <div key={cake.id} className="col-md-3 col-sm-6 py-2 gap-4 d-flex flex-column align-items-center">
            <div className="bg-white rounded_div shadow-lg overflow-hidden flex-1 flex flex-col" role="button" onClick={() => onCardClick(cake.id)}>
              <img src={cake.image} alt={cake.name} loading="lazy" className="home__topnft_img"/>
              <div className="p-4 flex-1 flex flex-col">
                <h3 className="mb-2 text-2xl">{cake.name}</h3>
                <p className="mb-4" style={{ fontSize: 17, fontWeight: 700, color: "#c2185b" }}>{cake.price}</p>
                <Button type="primary" onClick={(e) => { e.stopPropagation(); onCardClick(cake.id); }}>
                  Request quote
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeddingCakes;
